// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    agentsLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69848aad12cd46e0bd5b633b_monday-agents-logo.svg",
        alt: ""
    },
    earlyAccessText: "Early Access",
    headingBlack: "that amplifies your team’s impact",
    headingGradient: "Unlimited workforce ",
    hideComponent: true,
    primaryButtonText: "Request Early Access",
    requestEarlyAccessLink: {
        href: "https://wkf.ms/3OgWfIa",
        target: "_self"
    },
    secondaryButtonText: "Learn more <br />",
    sectionSubtitleText: "Expand what you can achieve with ready-made or custom AI agents <br /> that act where you already work."
};
